module.exports = __webpack_public_path__ + "static/media/5.question_loop.389eff31.mp4";